<template>
  <!-- Navbar -->
  <nav class="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl " id="navbarBlur"
    data-scroll="false">
    <div class="container-fluid py-1 px-3">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
          <li class="breadcrumb-item text-sm"><router-link to="/dashboard">Tableau de Bord</router-link></li>
          <li class="breadcrumb-item text-sm text-white active" aria-current="page">{{ currentPage }}</li>
        </ol>
        <h6 class="font-weight-bolder text-white mb-0">{{ currentPage }}</h6>
      </nav>
      <!-- ouverture/fermeture de la sidenav -->
        <!-- <button class="btn btn-icon btn-3 btn-secondary btn-sm position-absolute top-0 start-0 mt-3 ms-3"
          @click="toggleSidebar" type="button">
          <i class="fas" :class="{ 'fa-times': sidebarOpen, 'fa-bars': !sidebarOpen }"></i>
      </button> -->
    </div>
  </nav>
  <!-- End Navbar -->

</template>


<script>
export default {

  //ouverture/fermeture de la sidenav

  // computed: {
  //   sidebarOpen() {
  //     return this.$store.state.sidebarOpen;
  //   },
  // },
  data() {
    return {
      currentPage: 'Tableau de Bord',
    };
  },
  
  //ouverture/fermeture de la sidenav
  // methods: {
  //   toggleSidebar() {
  //     this.$store.commit('toggleSidebar');
  //   },
  // },
  watch: {
    // maj du nom de la page en fonction de la route actu
    $route(to) {
      this.currentPage = to.name || 'Page Inconnue';
    },
  },
};
</script>